import { IonButton, IonCol, IonGrid, IonList, IonLoading, IonRow } from '@ionic/react';
import React, { useEffect } from 'react';
import ArtistItem from '../components/ArtistItem';
import Content from '../components/Content';
import { useArtists } from '../data/store/useArtists';
import { usePageTitle } from '../util/sugar';

interface ArtistListProps { }

const ArtistList: React.FC<ArtistListProps> = () => {
  const status = useArtists(x => x.status);
  const roster = useArtists(x => x.roster);
  const rosterDone = useArtists(x => x.rosterDone);
  const pageSize = useArtists(x => x.pageSize);
  const fetchNextRosterPage = useArtists(x => x.fetchNextRosterPage);
  const observeTopRoster = useArtists(x => x.observeTopRoster);
  const stopObservingTopRoster = useArtists(x => x.stopObservingTopRoster);

  usePageTitle('Artists');

  useEffect(() => {
    if (roster.length === 0) {
      fetchNextRosterPage();
    }
    observeTopRoster(pageSize);
    return () => stopObservingTopRoster();
  }, []);

  const parentRef = React.useRef<HTMLIonListElement>(null);

  return (
    <Content className='chill'>
      <IonGrid>
        <IonRow>
          <IonLoading isOpen={roster.length === 0 && (status === 'fetching' || status === 'initial')} />
          <IonCol sizeMd='6' offsetMd='3' sizeXs='12'>
            <IonList ref={parentRef}>
              {roster.map(artistId => (
                <ArtistItem key={artistId} id={artistId} />
              ))}
              {!rosterDone && (
                <IonButton
                  fill='outline'
                  color='dark'
                  expand='full'
                  disabled={status === 'fetching'}
                  onClick={() => fetchNextRosterPage()}
                >
                  {status === 'fetching' ? 'Loading…' : 'Load More'}
                </IonButton>
              )}
            </IonList>
          </IonCol>
        </IonRow>
      </IonGrid>
    </Content>
  );
};

export default (ArtistList);
